/* eslint-disable react/no-array-index-key */
import classNames from 'classnames'
import qs from 'qs'
import React, { useCallback } from 'react'
import { useLocation } from 'react-router'
import * as styles from './Gallery.module.scss'
import { templates } from './gallery.type'
import Lightbox from './Lightbox'
import ProductInterface, { PriceInterface } from '../../../interfaces/ProductInterface'
import { getFullProductName, getProductEvent } from '../../../utils/product'
import { _at } from '../../../utils/translations'
import Photo from '../../Photo/Photo'
import Video from '../../Video/Video'

const GTM_CLASS_PRODUCT_GALLERY = 'gtm-product-gallery'

type Props = {
  product: ProductInterface
  price?: PriceInterface
}

export const Gallery = (props: Props) => {
  const { product } = props
  const [lightbox, setLightbox] = React.useState<number>(-1)
  const location = useLocation()
  const searchParams: { g?: number } = qs.parse(location.search, { ignoreQueryPrefix: true, parseArrays: false })
  const galleryLayout = product.galleryLayout //searchParams.g!//test only

  const images = product.description.photos?.product || [
    {
      catalog: true,
      id: -1,
      position: 0,
      product: true,
      url: '/img/not_found.jpg',
      mediaType: 1,
    },
  ]

  const template = templates[galleryLayout] || templates[4]
  return (
    <div className={`${styles['box']} ${GTM_CLASS_PRODUCT_GALLERY}`} data-gtmvalue={_at('title', product.description.translations)}>
      {template.map((placement, idx) => {
        const itemClasses = classNames(styles['item'], {
          [styles['item-100']]: placement.width === 100,
          [styles['item-50']]: placement.width === 50,
          [styles['item-33']]: placement.width === 33,
        })

        const imgClasses = classNames(styles['item__img'], {
          [styles['item__img--100']]: placement.width === 100,
        })

        if (!images[idx]) {
          return null
        }

        const event = idx === 0 ? getProductEvent(product) : null
        return (
          <div key={`g-${idx}`} className={itemClasses}>
            {images[idx].mediaType === 2 ? (
              <Video
                sources={[{ src: images[idx].url, type: 'video/mp4', withCredentials: true }]}
                options={{ cover: true, fill: false, responsive: true, controls: true, fluid: true }}
              />
            ) : (
              <Photo
                src={images[idx].url}
                alt={getFullProductName(product)}
                classes={imgClasses}
                noEmpty
                onClick={() => setLightbox(idx)}
              />
            )}

            {event ? <div className={styles['event']}>{event.stringValue}</div> : null}
          </div>
        )
      })}
      <Lightbox items={images} open={lightbox > -1} onClose={() => setLightbox(-1)} index={lightbox} loop showCounter />
      {props.price?.percentDiscountAmount ? (
        <div aria-label="Discount" className={styles['discount']}>
          -{props.price?.percentDiscountAmount}%
        </div>
      ) : null}
    </div>
  )
}

export default Gallery
